import React from "react";
import PropTypes from "prop-types";
import {Link} from "react-scroll";

import styles from "./links.module.scss";

function Links(props) {
  const {items} = props;
  return (
    <div className={styles.root}>
      {items.map(({id, title}) => (
        <Link
          key={id}
          className={styles.link}
          activeClass={styles.active}
          spy={true}
          to={id}
          smooth={true}
          duration={500}
        >
          {title}
        </Link>
      ))}
    </div>
  );
}

Links.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string
    })
  )
};

export default Links;
